export const placeInfo=[
    {
        id:1,
        headerTitle:'Frontend',
        headerSubtitle:'React, Css, SE6',
        description:'Used top new technologies as REact framework, ECMAScript 6 with webGl and Three library',
        works:'Jobs done',
        example1:'(Click) Multi tenant Saas application for schools',
        lexample1:'https://escuela.rosys.im/',
        example2:'(Click) Rental car application',
        lexample2:'https://g3cars.clincoln.tech/'
    },
    {
        id:2,
        headerTitle:'Backend',
        headerSubtitle:'SQL, Spring Boot framework, Data migration, Node, Heroku',
        description:'Large systems Architecture design | Spring Boot , sql, json, ajax, java, Node, Python | Experience with large robust enterprise applications',
        works:'Projects',
        example1:'API builded with Python to analyze survey data with AI',
        lexample1:'https://github.com/nefigarcia/feedbackAI.git'

    },
    {
        id:3,
        headerTitle:'Data',
        headerSubtitle:'AI Agents, AI tools, HP AML, SQL,Access, Excel, tableau, Kafka, Airflow, Python, Java, Tableau, SSIS, GCP(Bigquery), Snowflake, Spark, AWS(S3), AI tools Copilot, Gemini Firebase',
        description:'ETL Development | Automated Data Pipelines | Data Visualization | Scalable Code Solutions | AI Agents and AI tools for data analysis and insights | Cloud Data Solutions (GCP, AWS) | Data Cleaning and Transformation | SQL and NoSQL Databases | Machine Learning Integration | Real-time Data Processing with Kafka and Spark | Data Warehousing with Snowflake and BigQuery | Business Intelligence with Tableau and Power BI',
        works:'Projects',
        example1:'(Click) Jobs Analysis, pipeline automatation for ETL process',
        lexample1:'https://datapipelinejobs.rosystems.net/',
        example2:'(Click) Github repository',
        lexample2:'https://github.com/nefigarcia/outsourcing-analysis',
        example3:'(Click) HealthAI with AI Agent and AI tools',
        lexample3:'https://healthai.rosystems.net',
        example4:'(Click) Github repository for HealthAI',
        lexample4:'https://github.com/nefigarcia/HealthAI-assistant.git'
    },
    {
        id:4,
        headerTitle:'AI Agents and AI tools',
        headerSubtitle:'AI Agents, AI tools, AI Copilot, Gemini Firebase, Studio AI, Claudia AI',
        description:'AI-Powered Applications | Prompt Engineering | AI Chatbots and Assistants | AI for Process Optimization | Autonomous Agents | AI Integration with Web and Cloud Platforms',
        works:'Projects',
        example1:'(Click) Sentiment Analysis with AI Agent and AI tools',
        lexample1:'https://surveyai.rosystems.net/',
        example2:'(Click) Github repository',
        lexample2:'https://github.com/nefigarcia/feedbackAI.git',
        example3:'(Click) HealthAI with AI Agent and AI tools',
        lexample3:'https://healthai.rosystems.net',
        example4:'(Click) Github repository for HealthAI',
        lexample4:'https://github.com/nefigarcia/HealthAI-assistant.git'
    }
];
export const detailInfo=
{
    id:1,
    headerTitle:'Frontend',
    

};